function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.831 5.406l-.037-.075s0-.056-.044-.081L13.906 1.5a.625.625 0 00-.5-.25H5a1.875 1.875 0 00-1.875 1.875v13.75A1.875 1.875 0 005 18.75h10a1.875 1.875 0 001.875-1.875V5.625a.626.626 0 00-.044-.219zM15 5h-1.25V3.362L15 5zm0 12.5H5a.625.625 0 01-.625-.625V3.125A.625.625 0 015 2.5h7.5V5a1.25 1.25 0 001.25 1.25h1.875v10.625A.624.624 0 0115 17.5z",
  fill: "#28293D"
});

function SvgPage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPage;